import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { customTheme } from "./styles/theme";
import Fonts from "./styles/Fonts";
import { ChakraProvider } from "@chakra-ui/react";
import "./styles/custom.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ChakraProvider theme={customTheme}>
        <Fonts />
        <App />
      </ChakraProvider>
    </BrowserRouter>
  </React.StrictMode>
);
